import React from "react";
import { Link } from "react-router-dom";

export default function NinReuseNotice({ evidence }: { evidence: any }) {
  if (!evidence) return null;
  const matches: any[] = evidence.matches || [];
  return <div role={matches.length ? "alert" : "status"} className={`rounded-lg border p-4 my-4 text-sm ${matches.length ? "border-amber-500 bg-amber-50" : "border-gray-200 bg-gray-50"}`}>
    <p className="font-semibold">{matches.length ? "NIN previously submitted" : evidence.checked ? "No matching NIN on another account" : "NIN reuse check unavailable"}</p>
    {!evidence.checked && <p>{evidence.message}</p>}
    {matches.length > 0 && <><p>Review these submissions before deciding this ID check.</p><ul className="mt-2 space-y-2">
      {matches.map(match => <li key={match.verificationId}>
        <Link className="underline" to={`/id-check/${match.verificationId}/verify-nin`}>{match.name}</Link>
        {` — ${match.status}${match.deleted ? " (deleted account)" : ""}`}
      </li>)}
    </ul></>}
  </div>;
}
